import { observer } from "mobx-react-lite";
import './ColorCard.scss'
import { Badge } from "./Badge";
import BadgeIcon from "./BadgeIcon";
import PetTooltip from "./PetTooltip";
import { InfoIcon } from "../icons/InfoIcon";
import CornerCheck from "../icons/CornerCheck";
import { publicUrl } from "../utils/url";
import Img from "./Img";
import { prepareDataAttributesObject } from "../utils/HtmlUtils";
import ExpandIcon from "../icons/ExpandIcon";
import { store } from "../stores/Store";


const ColorCard = observer(({ data, name, checked = false, className = '', imageUrl = publicUrl('/assets/fabric.png'), onClick }) => {

    var classes = ['ColorCard', className];
    if (checked) {
        classes.push('ColorCard--checked')
    }

    return (
        <div onClick={onClick} className={`${className} ${classes.join(' ')}`} {...prepareDataAttributesObject(data)}>
            <div className="ColorCard__body">
                <div className="ColorCard__photo">
                    <Img src={imageUrl} />
                    {/* <img src={imageUrl} alt="" /> */}

                    <div className="ColorCard__photo-name">{name}</div>
                    <button
                        type="button"
                        onClick={e => {
                            store.openPreview(imageUrl, 'md', '1');
                        }}
                        className={"ColorCard__info-icon"}>
                        <ExpandIcon />
                    </button>
                    {/* <InfoIcon className={"ColorCard__info-icon"} /> */}
                </div>
                <div className="ColorCard__text">
                    <div className="ColorCard__title">{name}</div>

                </div>
                {checked && <CornerCheck className="ColorCard__check" />}

            </div>
        </div>
    )
});

ColorCard.displayName = 'ColorCard'
export default ColorCard